/* CamWood Ambassadors — Poster Wall.
   The page is fully functional with this file absent: the posters render and
   the stories open on their own, because they are <details>. All this does is
   measure the scrollbar so the full-bleed section cannot overflow sideways.

   The posters are deliberately NOT clickable — they are shown at a size that
   reads on its own, so there is nothing to expand and nothing to escape from. */
(function () {
  if (!document.querySelector('[data-cwa-root]')) return;

  /* `50vw` includes the scrollbar, so the full-bleed negative margins overflow
     by exactly the scrollbar width wherever scrollbars take up space (Windows,
     mainly). Measure it so the CSS can subtract it. */
  function gutter() {
    var sb = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--cwa-sb', (sb > 0 ? sb : 0) + 'px');
  }
  gutter();
  window.addEventListener('resize', gutter);
})();
